import RoleDescriptionDialog from './RoleDescriptionDialog';

export default RoleDescriptionDialog;
